import { createSlice } from "@reduxjs/toolkit";
import { FilterStateStores } from "@/pages/conciliation/stores/ducks/filter/types";

const INITIAL_STATE: FilterStateStores = {
  filters: {
    meta: {
      page: 1,
    },
  },
};

const filterSlice = createSlice({
  name: "filter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter } = filterSlice.actions;
export default filterSlice.reducer;
